import React from 'react';
import ReviewHeader from '../reviewHeader/ReviewHeader';
import {
  reviewHeaderDesktop,
  reviewHeaderTab,
  reviewHeaderMobile,
} from '../../../../src/images';
import styles from './ReviewPage.module.scss';
import ReviewGrid from '../reviewGrid/ReviewGrid';
import { customerStoriesImg } from '../../../../src/images';
import { ProductsCategory } from '../../../../config';
import { productsKeyConstants } from '../../../../config';
import CustomerReview from '../customerReview/CustomerReview';
import YotpoReviews from '../../global/YotpoReviews/YotpoReviews';
import ProductCarousel from '../../global/ProductCarousel/ProductCarousel';

const ReviewPage = () => {
  const HeroContent = {
    img: {
      small: reviewHeaderMobile,
      medium: reviewHeaderTab,
      large: reviewHeaderDesktop,
    },
    subTitle: 'Reviews',
    mainTitle: 'Helping People <br /> Feel the Difference',
  };

  const Reviews = [
    {
      rating: 5,
      reviewContent:
        "When you have pain for 6 years and start taking <span class='noLineBreak'>Relief Factor</span> and start feeling pain free you can't believe it.",
      userImg: customerStoriesImg,
      username: '- Art D.',
      productname: 'Relief Factor',
      product: ProductsCategory.RELIEF_FACTOR,
    },
    {
      rating: 5,
      reviewContent:
        'I absolutely love <span class="noLineBreak">Zen Factor</span>. I tell all my friends about it.',
      userImg: customerStoriesImg,
      username: '- Drew M.',
      productname: 'Zen Factor',
      product: ProductsCategory.ZEN_FACTOR,
    },
    {
      rating: 5,
      reviewContent:
        '<span class="noLineBreak">Go Factor</span> is one of your more phenomenal products, when you take it, you instantly know you took it! Thank you for having such a great product and a good company.',
      userImg: customerStoriesImg,
      username: '- Melonie M.',
      productname: 'Go Factor',
      product: ProductsCategory.GO_FACTOR,
    },

    {
      rating: 5,
      reviewContent:
        'I just had to share how thankful I am for your product. I was unable to I get a full nights sleep for over a year!! But now after taking your product, I can sleep!! It took a full month to work for me but thank God it works! Thank you!!!',
      userImg: customerStoriesImg,
      username: '- Brenda M.',
      productname: 'Z Factor',
      product: ProductsCategory.Z_FACTOR,
    },
  ];
  return (
    <>
      <ReviewHeader content={HeroContent} darkContent />
      <ReviewGrid reviews={Reviews} />
      <CustomerReview />
      <div className={styles.yotpoReviewExtender}>
        <div className={styles.yotpoReviewContainer}>
          <YotpoReviews
            product={productsKeyConstants.RF_RELIEF_FACTOR_QS}
            showDropdown={true}
          />
        </div>
      </div>
      <ProductCarousel />
    </>
  );
};

export default ReviewPage;
